function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgBuggy = function SvgBuggy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49 2.47c0-1.218.987-2.205 2.205-2.205h10.268c1.149 0 2.092.878 2.196 2l2.636 6.708 7.35 1.058a3.742 3.742 0 011.834.805l1.474 1.204c.505.411.797 1.028.797 1.678v2.305c0 1.197-.97 2.167-2.167 2.167h-1.04a4.138 4.138 0 01-8.192-.018l-10.645-.358a4.532 4.532 0 11-7.542-3.958H3.23c-.535 0-1.05-.197-1.448-.554l-.574-.516a1.379 1.379 0 01-.293-1.68l.628-1.167a3.743 3.743 0 013.296-1.97h2.13V5.45c0-.268.049-.53.143-.775h-.417A2.204 2.204 0 014.49 2.469zm4.015 2.204a.595.595 0 01-.066.079.985.985 0 00-.289.696v2.52h1.495c.588 0 1.151.24 1.56.662l1.165 1.207V7.301a.591.591 0 011.182 0v3.476c.878.525 1.889.809 2.93.809h.647c.573 0 1.128-.192 1.577-.543l-.726-.693-.322.286a.591.591 0 01-.785-.884l.726-.643a.984.984 0 01.009-.008l.724-.642a.591.591 0 01.784.884l-.248.22.736.702 1.064-.927-2.104-5.354c-.401.425-.97.69-1.6.69H8.505zm9.45-2.454a.589.589 0 00.03.29c-.021.546-.47.982-1.021.982H6.694a1.023 1.023 0 110-2.046h10.27c.478 0 .88.33.991.774zm3.6 7.913l-1.967 1.714a3.743 3.743 0 01-2.46.92h-.646c-1.87 0-3.661-.76-4.96-2.105l-1.168-1.21a.985.985 0 00-.709-.3H4.84a2.56 2.56 0 00-2.255 1.347l-.629 1.168a.197.197 0 00.042.24l.575.515c.18.162.415.252.658.252h3.486a4.531 4.531 0 014.494 3.958l10.646.357a4.138 4.138 0 018.187.019h1.04a.985.985 0 00.985-.985v-2.305a.985.985 0 00-.362-.763l-1.474-1.203a2.56 2.56 0 00-1.255-.551l-7.422-1.068zm-14.84 3.723a3.349 3.349 0 100 6.698 3.349 3.349 0 000-6.698zm19.233.788a2.955 2.955 0 100 5.91 2.955 2.955 0 000-5.91z",
    fill: props.color
  }));
};
SvgBuggy.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgBuggy.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgBuggy;